<template>
    <!-- Base button -->
    <vs-button
        v-if="this.color !== 'hyperlead'"
        :class="classObject"
        :color="this.onColor()"
        :to="this.to"
        :type="type"
        @click="onClick"
        :disabled="disabled"
        :icon="icon"
        icon-pack="feather"
    >
        <slot></slot>
    </vs-button>

    <!-- Hyperlead button -->
    <vs-button
        v-else
        class="vs-button-custom vs-button-custom--hyperlead"
        :to="this.to"
        :type="type"
        @click="onClick"
        :disabled="disabled"
        :icon="icon"
        icon-pack="feather" >
        <slot></slot>
    </vs-button>
	
</template>

<script>
import themeConfig from "../../themeConfig";

export default {
    name: "Button",
    props: {
        color: String,
        type: String,
        to: String | Object | Array,
        disabled: Boolean,
        icon: String,
        htmlType: String,

        transparent: Boolean,
        outlined: Boolean,

        size: {
            type: String,
        }, // "xs" | "sm"
    },

    data() {
        return {
            
        };
    },

    computed: {
        classObject() {
           return {
                "vs-button-custom": true,
            
                // types
                "vs-button-transparent": this.type === "tranpsarent",
                "vs-button--sm": this.size === "sm",
                "vs-button--xs": this.size === "xs",

                // colors
                "vs-button--primary": this.color === "primary",
                "vs-button--success": this.color === "success",
                "vs-button--warning": this.color === "warning",
                "vs-button--danger": this.color === "danger",
                "vs-button--dark": this.color === "dark",
                "vs-button--blue": this.color === "blue",
                "vs-button--white": this.color === "white",
                "vs-button--grey": this.color === "grey",
                "vs-button--transparent": this.color === "transparent",
           }
        }
    },

    methods: {
        syncHtmlTypeInButton() {
            if(this.htmlType === "submit") {
                this.$el.setAttribute("type", "submit");
            }
        },

        onColor() {
            try {
                return themeConfig.colors[this.color];
            } catch (_) {
                return this.color;
            }
        },

        onClick() {
            this.$emit("click");
        }
    },

    mounted() {
        this.syncHtmlTypeInButton();
    }
};
</script>

<style lang="scss">
.vs-button-custom {
    padding: 10px 32px !important;
    border-radius: 3px;

    .vs-button-text {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .vs-button--icon {
        //margin-right: 1rem!important;
        transform: scale(1.25);
    }

    &.vs-button-filled {
        &.vs-button-custom--hyperlead {
            background: var(--vs-hex-hyperlead) !important;
            color: var(--vs-hex-white);
            font-weight: 500!important;
        }

        &.vs-button--primary {
            background-color: rgba(var(--vs-primary), 1); 
            color: var(--vs-hex-white);
            font-weight: 500!important;
        } 

        &.vs-button--success {
            background-color: rgba(var(--vs-success), 1); 
            color: var(--vs-hex-white);
            font-weight: 500!important;
        } 

        &.vs-button--warning {
            background-color: rgba(var(--vs-warning), 1); 
            color: var(--vs-hex-white);
            font-weight: 500!important;
        } 
        
        &.vs-button--danger {
            background-color: rgba(var(--vs-danger), 1); 
            color: var(--vs-hex-white);
            font-weight: 500!important;
        } 

        &.vs-button--dark {
            background-color: rgba(var(--vs-dark), 1); 
            color: var(--vs-hex-white);
            font-weight: 500!important;
        } 

        &.vs-button--blue {
            background-color: rgba(var(--vs-blue), 1); 
            color: var(--vs-hex-white);
            font-weight: 500!important;
       }

        &.vs-button--white {
            background-color: rgba(var(--vs-white), 1);
            color: var(--vs-hex-dark);
            font-weight: 500!important;
        }

        // Only filled have grey color
        // For offer have button paused status
        &.vs-button--grey {
            background-color: #EFEFEF!important;
            color: var(--vs-hex-gray);
            font-weight: 500!important;
            border: 1px solid #EFEFEF;

            &:hover {
                box-shadow: 0 2px 12px rgba($color: #EFEFEF, $alpha: 0.15);
            }
        }
    }

    &.vs-button-outlined {
        transition: all 50ms ease;

        &.vs-button-custom--hyperlead {
            border: 1px solid var(--vs-hex-primary);
            color: var(--vs-hex-primary);
            font-weight: 500;

            &:hover {
                background: var(--vs-hex-hyperlead);
                color: var(--vs-hex-white);
            }
        }

        &.vs-button--primary {
            border: 1px solid rgba(var(--vs-primary), 1); 
            color: var(--vs-hex-primary);
            font-weight: 500;
        } 

        &.vs-button--success {
            border: 1px solid rgba(var(--vs-success), 1); 
            color: var(--vs-hex-success);
            font-weight: 500;
        } 

        &.vs-button--warning {
            border: 1px solid rgba(var(--vs-warning), 1); 
            color: var(--vs-hex-warning);
            font-weight: 500;
        } 
        
        &.vs-button--danger {
            border: 1px solid rgba(var(--vs-danger), 1); 
            color: var(--vs-hex-danger);
            font-weight: 500;
        } 

        &.vs-button--dark {
            border: 1px solid rgba(var(--vs-dark), 1); 
            color: var(--vs-hex-dark);
            font-weight: 500;
        } 

        &.vs-button--blue {
            border: 1px solid rgba(var(--vs-blue), 1); 
            color: var(--vs-hex-blue);
            font-weight: 500;

            &:hover {
                background: var(--vs-hex-blue);
                color: var(--vs-hex-white);
            }
        }

        &.vs-button--white {
            border: 1px solid rgba(var(--vs-white), 1);
            color: var(--vs-hex-white);
            font-weight: 500;
        }

        &.vs-button--grey {
            border: 1px solid var(--vs-hex-grey);
            color: var(--vs-hex-grey);
            font-weight: 500;
        }
    }

    &.vs-button-transparent {
        &.vs-button--primary {
            font-weight: 500;
            background-color: rgba(var(--vs-primary), 0.2); 
            color: rgba(var(--vs-primary), 1);

            &:hover {
                box-shadow: 0 2px 12px rgba(var(--vs-primary), 0.15);
            }
        } 

        &.vs-button--success {
            font-weight: 500;
            background-color: rgba(var(--vs-success), 0.2); 
            color: rgba(var(--vs-success), 1);

            &:hover {
                box-shadow: 0 2px 12px rgba(var(--vs-success), 0.15);
            }
        } 

        &.vs-button--warning {
            font-weight: 500;
            background-color: rgba(var(--vs-warning), 0.2); 
            color: rgba(var(--vs-warning), 1);

            &:hover {
                box-shadow: 0 2px 12px rgba(var(--vs-warning), 0.15);
            }
        } 
        
        &.vs-button--danger {
            font-weight: 500;
            background-color: rgba(var(--vs-danger), 0.2); 
            color: rgba(var(--vs-primary), 1);

            &:hover {
                box-shadow: 0 2px 12px rgba(var(--vs-danger), 0.15);
            }
        } 

        &.vs-button--dark {
            font-weight: 500;
            background-color: rgba(var(--vs-dark), 0.2); 
            color: rgba(var(--vs-dark), 1);

            &:hover {
                box-shadow: 0 2px 12px rgba(var(--vs-dark), 0.15);
            }
        } 

        &.vs-button--blue {
            font-weight: 500;
            background-color: rgba(var(--vs-blue), 0.2); 
            color: rgba(var(--vs-blue), 1);

            &:hover {
                box-shadow: 0 2px 12px rgba(var(--vs-blue), 0.15);
            }
        }
		&.vs-button--transparent {
			font-weight: 500;
			background-color: transparent;
			color: rgba(var(--vs-dark), 1);
			&:hover {
				box-shadow: none;
			}
		}
    }

    &.vs-button-relief {
        transform: translateY(-1.5px);
    }

    &.vs-button--sm {
        font-size: 13px;
        padding: 8px 18px !important;
    }
    
    &.vs-button--xs {
        font-size: 11px;
        padding: 8px 18px !important;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Button/Button.vue